import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  PLATFORM_ID, QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLink} from '@angular/router';
import {Meta, Title} from '@angular/platform-browser';
import {filter} from 'rxjs';
import {isPlatformBrowser, NgForOf, NgIf} from '@angular/common';
import {BilletsService} from '../../services/billets.service';
import {SettingsComponent} from '../../components/settings/settings.component';
import {cookiesService} from '../../services/cookies.service';
import {SettingsService} from '../../services/settings.service';

@Component({
  selector: 'trenerovachnyy-ekzamen-page',
  templateUrl: './trenerovachnyy_ekzamen.component.html',
  imports: [
    NgForOf,
    NgIf,
    SettingsComponent,

  ],
  styleUrl: './trenerovachnyy_ekzamen.component.less'
})
export class TrenerovachnyyEkzamenPageComponent {
  @ViewChildren('billet')
  billets!: QueryList<ElementRef<HTMLElement>>;

  @ViewChild('scrollContainerBillets')
  scrollContainerBillets!: ElementRef<HTMLDivElement>;

  @ViewChild('timerHTML', { static: true })
  timerHTML!: ElementRef<HTMLDivElement>;


  id_question: number = 0
  bilet_index: number = -1
  question_index: number = -1

  open_explanation = false
  active_billet = 0

  scroll_billets: any = {
    all_billets: false,
    isDragging: false,
    startX: 0,
    scrollLeft: 0,
    moved: false,
    element: null as HTMLElement | null,
    isEnd: false
  }

  public totalSeconds = 20 * 60; // 20 минут

  public timer: any;
  public endTime = 0;



  my_answer_bilet_trenerovachnyy_ekzamen: any = {}
  questionsMap = new Map<number, any>();
  constructor(private cdr: ChangeDetectorRef, public SettingsService: SettingsService,   public BilletsService: BilletsService,  @Inject(PLATFORM_ID) private platformId: Object, private router: Router, private title: Title, private meta: Meta) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {
          this.SettingsService.set_open_settings(false)
          this.active_billet = 0
          this.bilet_index = Math.floor(
            Math.random() * this.BilletsService.billets_list.length
          );

          this.BilletsService.my_answer_bilet_trenerovachnyy_ekzamen = []

          for (let i =0;  i < this.BilletsService.billets_question.length; i++) {
            this.BilletsService.billets_question[i].bilet_trenerovachnyy_ekzamen = {}
          }
          this.question_index = 0;


          window.scrollTo({
            top: 0,
            behavior: 'smooth' // или убери behavior для мгновенного скролла
          });
        }
      });

  }

  ngAfterViewInit() {
    this.scrollContainerBillets.nativeElement.scrollLeft = 0
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {
          this.scrollBileetsList()
        }
      });

  }

  scrollBileetsList() {
    const element = this.billets.get(this.question_index);
    if (this.scroll_billets.all_billets == false) {
      element?.nativeElement.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',   // start | center | end | nearest
        block: 'nearest'
      });
    }
  }

  ngOnInit(): void {
    this.bilet_index = Math.floor(
      Math.random() * this.BilletsService.billets_list.length
    );

    this.BilletsService.my_answer_bilet_trenerovachnyy_ekzamen = []

    for (let i =0;  i < this.BilletsService.billets_question.length; i++) {
      this.BilletsService.billets_question[i].bilet_trenerovachnyy_ekzamen = {}
    }
    this.question_index = 0;
    this.loadBilet()
    if (isPlatformBrowser(this.platformId)) {
      this.startTimer();
    }

  }


  startTimer(): void {

    this.endTime = Date.now() + this.totalSeconds * 1000;

    this.timer = setInterval(() => {

      this.totalSeconds = Math.max(
        0,
        Math.floor((this.endTime - Date.now()) / 1000)
      );


      let text_timer:string =  `${Math.floor(this.totalSeconds / 60).toString().padStart(2, '0')}:` +
        `${(this.totalSeconds % 60).toString().padStart(2, '0')}`;

      this.timerHTML.nativeElement.textContent = text_timer.toString()


      if (this.totalSeconds === 0) {
        clearInterval(this.timer);

        // Здесь завершение экзамена
        alert('Время вышло!');

        this.cdr.detectChanges();
      }




    }, 1000);

  }



  ngOnDestroy(): void {
    clearInterval(this.timer);
  }


  loadBilet() {
    this.my_answer_bilet_trenerovachnyy_ekzamen = {}

    for (let i = 0; i < this.BilletsService.my_answer_bilet_trenerovachnyy_ekzamen.length; i++) {
      if (this.BilletsService.my_answer_bilet_trenerovachnyy_ekzamen[i].index_bilet == this.bilet_index) {

        this.my_answer_bilet_trenerovachnyy_ekzamen = this.BilletsService.my_answer_bilet_trenerovachnyy_ekzamen[i]
        break;
      }
    }




    this.id_question = this.BilletsService.billets_list[this.bilet_index][this.question_index]

    let question_title = ''
    for (let i = 0; i < this.BilletsService.billets_question.length; i++) {

      if (this.BilletsService.billets_question[i].id == this.id_question) {

        if (this.BilletsService.billets_question[i]?.bilet_all?.select) {
          this.open_explanation = true
        } else {
          this.open_explanation = false
        }
        question_title = '| ' + this.BilletsService.billets_question[i].question.text;
        break;
      }
    }


    this.title.setTitle('Тренировочный экзамен 👨🏼‍💻 ПДД 2026  | Онлайн подготовка | ПДД');

    this.meta.updateTag({
      name: 'description',
      content: `Тренировочный экзамен ПДД 2026. Пройдите онлайн тест с официальными вопросами, узнайте правильный ответ и подробное объяснение.`
    });

    this.meta.updateTag({
      name: 'keywords',
      content: `тренировочный экзамен ПДД, ПДД 2026, экзамен ПДД онлайн, подготовка к экзамену ГИБДД, билеты ПДД`
    });



    for (const q of this.BilletsService.billets_question) {
      this.questionsMap.set(q.id, q);
    }
  }

  onMouseDown(event: MouseEvent, element: HTMLElement) {
    this.scroll_billets.moved = false;
    if (this.scroll_billets.all_billets == false) {
      this.scroll_billets.isDragging = true;
      this.scroll_billets.element = element;

      this.scroll_billets.startX = event.pageX;
      this.scroll_billets.scrollLeft = element.scrollLeft;
    }

  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.scroll_billets.isDragging || !this.scroll_billets.element) {
      return;
    }

    const dx = event.clientX - this.scroll_billets.startX;
    if (dx > 15 || dx < -15) {
      this.scroll_billets.moved = true;
    }
    if (this.scroll_billets.moved == true) {

      this.scroll_billets.element.scrollLeft -= dx;

      this.scroll_billets.startX = event.clientX;
    }
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.scroll_billets.isDragging = false;
    this.scroll_billets.element = null;
  }


  openBillet(index: number) {
    this.question_index = index;
    this.loadBilet()
    this.scrollBileetsList()


  }

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    this.scroll_billets.scrollLeft = element.scrollLeft;

    this.scroll_billets.isEnd = element.scrollLeft + element.clientWidth >= element.scrollWidth - 25;

  }

  scrollLeft(element: HTMLElement) {
    element.scrollBy({
      left: -(element.clientWidth / 2),
      behavior: 'smooth'
    });
  }

  scrollRight(element: HTMLElement) {
    element.scrollBy({
      left: (element.clientWidth / 2),
      behavior: 'smooth'
    });
  }

  vueAllBillets() {
    this.scroll_billets.all_billets = !this.scroll_billets.all_billets
    if (this.scroll_billets.all_billet == false) {

      window.scrollTo({
        top: 0,
        behavior: 'smooth' // или убери behavior для мгновенного скролла
      });

    }

  }

  chekAnswer(question_index: number, answer_index: number) {


    const question = this.BilletsService.billets_question[question_index];

    if (!question?.bilet_trenerovachnyy_ekzamen?.select  &&  this.totalSeconds > 0) {

      let answer = this.BilletsService.billets_question[question_index].answers[answer_index].correct
      let index = -1
      for (let i = 0; i < this.BilletsService.my_answer_bilet_trenerovachnyy_ekzamen.length; i++) {
        if (this.BilletsService.my_answer_bilet_trenerovachnyy_ekzamen[i].index_bilet == this.bilet_index) {
          index = i
          this.BilletsService.my_answer_bilet_trenerovachnyy_ekzamen[i].list_question.push(
            {
              index_question: question_index,
              index_answer: answer_index
            }
          )
          this.my_answer_bilet_trenerovachnyy_ekzamen = this.BilletsService.my_answer_bilet_trenerovachnyy_ekzamen[i]
          break;
        }
      }
      if (index < 0) {
        let new_answer = {
          index_bilet: this.bilet_index,
          list_question: [
            {
              index_question: question_index,
              index_answer: answer_index
            }
          ]
        }
        this.BilletsService.my_answer_bilet_trenerovachnyy_ekzamen.push(new_answer)

        this.my_answer_bilet_trenerovachnyy_ekzamen = new_answer

      }
      this.BilletsService.billets_question[question_index].bilet_trenerovachnyy_ekzamen = {select: true, status: answer}


      for (let i = 0; i < this.BilletsService.billets_question[question_index].answers.length; i++) {
        if (i == answer_index) {
          this.BilletsService.billets_question[question_index].answers[i].bilett_trenerovachnyy_ekzamen_select = true
        } else {
          this.BilletsService.billets_question[question_index].answers[i].bilett_trenerovachnyy_ekzamen_select = false
        }
      }

      if (this.my_answer_bilet_trenerovachnyy_ekzamen.list_question.length == this.BilletsService.billets_list[this.bilet_index].length) {
        clearInterval(this.timer);
      }

      this.nextQuiz()
    }

  }

  nextQuiz() {
    if (this.question_index + 1 <= this.BilletsService.billets_list[this.bilet_index].length - 1) {
      this.openBillet(this.question_index + 1)
    }

  }

  count_error() {
    let count = 0;
    for (let j = 0; j < this.BilletsService.billets_list[this.bilet_index].length; j++) {
      for (let i = 0; i < this.BilletsService.billets_question.length; i++) {
        if (!this.BilletsService.billets_question[i].bilet_trenerovachnyy_ekzamen?.status && this.BilletsService.billets_list[this.bilet_index][j] == this.BilletsService.billets_question[i].id) {
          count++
        }
      }
    }

    return count
  }

  count_success() {
    let count = 0;
    for (let j = 0; j < this.BilletsService.billets_list[this.bilet_index].length; j++) {
      for (let i = 0; i < this.BilletsService.billets_question.length; i++) {
        if (this.BilletsService.billets_question[i].bilet_trenerovachnyy_ekzamen?.status && this.BilletsService.billets_list[this.bilet_index][j] == this.BilletsService.billets_question[i].id) {
          count++
        }
      }
    }
    return count
  }



}
